import { render } from "./RegionsVue.vue?vue&type=template&id=b0a7c7d2"
import script from "./RegionsVue.vue?vue&type=script&lang=js"
export * from "./RegionsVue.vue?vue&type=script&lang=js"

import "./RegionsVue.vue?vue&type=style&index=0&id=b0a7c7d2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__